export const GetCityName = () => {
  const CityName = process.env.cityName

  return [CityName]
}
